<div class="bastidores-container">
  <!-- Header -->
  <div class="bastidores-header">
    <h4>{{ "bastidores.title" | translate }}</h4>
    <div class="bastidores-actions">
      <button class="btn btn-primary" (click)="onCreateNew()">
        <i class="icon-plus"></i> {{ "bastidores.add_new" | translate }}
      </button>
      <button class="btn btn-secundario" (click)="toggleImport()">
        <i class="icon-upload"></i> {{ "bastidores.import_title" | translate }}
      </button>
      <button class="btn btn-secundario" (click)="onExport()">
        <i class="icon-download"></i> {{ "bastidores.export_title" | translate }}
      </button>
    </div>
  </div>

  <!-- Import panel -->
  <div *ngIf="showImportPanel" class="import-panel">
    <app-bastidores-import
      [campaignStockId]="campaignStockId"
      (importSuccess)="onImportComplete()">
    </app-bastidores-import>
  </div>

  <!-- Create/Edit form -->
  <div *ngIf="showCreateForm" class="form-panel">
    <h5>{{ (editingVin ? "bastidores.edit" : "bastidores.add_new") | translate }}</h5>
    <app-bastidores-form
      [editingVin]="editingVin"
      [ladata]="ladata"
      [campaignStockId]="campaignStockId"
      (saved)="onSave($event)"
      (cancelled)="onCancelForm()">
    </app-bastidores-form>
  </div>

  <!-- Table -->
  <div class="tabla" *ngIf="bastidores.length > 0; else noBastidores">
    <div class="table-responsive-wrapper">
      <div class="table-scroll-inner">
        <table class="table full-width-table">
          <thead>
            <tr>
              <th class="cabecera-tabla group-header">{{ "bastidores.group_vehicle" | translate }}</th>
              <th class="cabecera-tabla group-header">{{ "bastidores.group_manufacturer" | translate }}</th>
              <th class="cabecera-tabla group-header">{{ "bastidores.group_status" | translate }}</th>
              <th class="cabecera-tabla group-header"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of bastidores">
              <!-- Vehículo -->
              <td class="cell-group">
                <div class="field-row"><span class="field-label">{{ "bastidores.vin" | translate }}:</span> <span class="field-value vin-value">{{ item.vin || '-' }}</span></div>
                <div class="field-row"><span class="field-label">{{ "bastidores.license_plate" | translate }}:</span> <span class="field-value">{{ item.license_plate || '-' }}</span></div>
                <div class="field-row"><span class="field-label">{{ "bastidores.colour" | translate }}:</span> <span class="field-value">{{ item.colour || '-' }}</span></div>
              </td>
              <!-- Fabricante -->
              <td class="cell-group">
                <div class="field-row"><span class="field-label">{{ "bastidores.supplier_reference" | translate }}:</span> <span class="field-value">{{ item.supplier_reference || '-' }}</span></div>
                <div class="field-row"><span class="field-label">{{ "bastidores.vehicle_discount_code" | translate }}:</span> <span class="field-value">{{ item.vehicle_discount_code || '-' }}</span></div>
                <div class="field-row"><span class="field-label">{{ "bastidores.workshop" | translate }}:</span> <span class="field-value">{{ item.workshop_name || '-' }}</span></div>
                <div class="field-row"><span class="field-label">{{ "bastidores.manufacture_expected_date" | translate }}:</span> <span class="field-value">{{ item.manufacture_expected_date || '-' }}</span></div>
                <div class="field-row"><span class="field-label">{{ "inputs.dealership" | translate }}:</span> <span class="field-value">{{ item.dealership_name || '-' }}</span></div>
              </td>
              <!-- Estado -->
              <td class="cell-group cell-group-center">
                <div class="field-row">
                  <span *ngIf="item.state" class="badge text-badge-list" [ngClass]="getStateBadgeClass(item.state)">
                    {{ ("bastidores.state_" + item.state) | translate }}
                  </span>
                  <span *ngIf="!item.state">-</span>
                </div>
                <div class="field-row" *ngIf="item.external_state">
                  <span class="field-label">{{ "bastidores.external_state" | translate }}:</span>
                  <span class="field-value">{{ item.external_state }}</span>
                </div>
                <div class="field-row">
                  <span class="badge text-badge-list" [ngClass]="item.in_use ? 'text-action' : 'text-no-action'">
                    {{ (item.in_use ? "bastidores.yes" : "bastidores.no") | translate }}
                  </span>
                </div>
                <div class="field-row" *ngIf="item.notes">
                  <span class="field-label">{{ "bastidores.notes" | translate }}:</span>
                  <span class="field-value text-truncate-cell">{{ item.notes }}</span>
                </div>
              </td>
              <!-- Acciones -->
              <td class="actions-cell">
                <i class="icon-pencil text-success icon-actions" (click)="onEdit(item)" title="{{ 'buttons.edit' | translate }}"></i>
                <i *ngIf="!item.in_use" class="icon-trash2 text-danger icon-actions" (click)="onDelete(item)" title="{{ 'buttons.delete' | translate }}"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <mat-paginator
      #paginator
      [length]="total"
      [pageIndex]="pageNumber - 1"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 50]"
      (page)="onPageChange($event)"
    ></mat-paginator>
  </div>

  <!-- Cards mobile -->
  <div class="cards-mobile-wrapper" *ngIf="bastidores.length > 0">
    <div class="bastidor-card" *ngFor="let item of bastidores" [ngClass]="{ 'in-use': item.in_use }">
      <div class="card-header">
        <div class="card-header-content">
          <div class="card-header-top">
            <span class="card-ref">{{ item.vin || '-' }}</span>
            <span *ngIf="item.state" class="badge text-badge-list" [ngClass]="getStateBadgeClass(item.state)">
              {{ ("bastidores.state_" + item.state) | translate }}
            </span>
          </div>
          <div class="card-tags" *ngIf="item.supplier_reference || item.license_plate">
            <span class="badge badge-secondary" *ngIf="item.supplier_reference">{{ item.supplier_reference }}</span>
            <span class="badge badge-secondary" *ngIf="item.license_plate">{{ item.license_plate }}</span>
          </div>
        </div>
      </div>
      <div class="card-body-content">
        <span *ngIf="item.colour"><i class="icon-paint-format"></i> {{ item.colour }}</span>
        <span *ngIf="item.vehicle_discount_code"><i class="icon-tag"></i> {{ item.vehicle_discount_code }}</span>
        <span *ngIf="item.workshop_name"><i class="icon-wrench"></i> {{ item.workshop_name }}</span>
        <span *ngIf="item.dealership_name"><i class="icon-home"></i> {{ item.dealership_name }}</span>
        <span *ngIf="item.manufacture_expected_date"><i class="icon-clock"></i> {{ item.manufacture_expected_date }}</span>
        <span *ngIf="item.external_state"><i class="icon-flag"></i> {{ item.external_state }}</span>
        <span *ngIf="item.notes" class="text-truncate-cell"><i class="icon-file-text2"></i> {{ item.notes }}</span>
      </div>
      <div class="card-footer">
        <div class="card-in-use-badge">
          <span class="badge text-badge-list" [ngClass]="item.in_use ? 'text-action' : 'text-no-action'">
            {{ (item.in_use ? "bastidores.yes" : "bastidores.no") | translate }}
          </span>
        </div>
        <div class="card-actions">
          <i class="icon-pencil text-success icon-actions" (click)="onEdit(item)" title="{{ 'buttons.edit' | translate }}"></i>
          <i *ngIf="!item.in_use" class="icon-trash2 text-danger icon-actions" (click)="onDelete(item)" title="{{ 'buttons.delete' | translate }}"></i>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state mobile -->
  <div class="cards-empty" *ngIf="bastidores.length === 0 && !showCreateForm && !showImportPanel">
    <i class="icon-info"></i> {{ "bastidores.no_bastidores" | translate }}
  </div>

  <!-- Empty state desktop -->
  <ng-template #noBastidores>
    <div class="empty-state" *ngIf="!showCreateForm && !showImportPanel">
      <div class="no-data-row">
        <i class="icon-info"></i>
        <span>{{ "bastidores.no_bastidores" | translate }}</span>
      </div>
    </div>
  </ng-template>
</div>
